"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkSearchStore = void 0;
const mobx_1 = require("mobx");
const workAPI = __importStar(require("@App/api/routes/work"));
const searchAPI = __importStar(require("@App/api/routes/search"));
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const generate_search_criterion_1 = require("@App/helpers/generate-search-criterion");
const get_work_autocomplete_suggestions_1 = __importDefault(require("@App/helpers/search/get-work-autocomplete-suggestions"));
const defaultMatchWorkSelectionCriteria = [
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(get_search_query_1.SEARCH_WORK_OPTIONS[0], true, true),
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(get_search_query_1.SEARCH_WORK_OPTIONS[3], true),
];
class WorkSearchStore {
    static createMatchWorkSearchCriteriaStore() {
        const maxCriteria = 2;
        return new search_criteria_store_1.default(defaultMatchWorkSelectionCriteria, get_search_query_1.SEARCH_WORK_OPTIONS, search_option_type_1.SearchOptionType.filter, required_criteria_1.RequiredCriteria.all, maxCriteria, [], get_work_autocomplete_suggestions_1.default);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksDraftsRightsHolder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksDraftsRightsHolderPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_matchWorksSelectionQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            _worksDraftsRightsHolder: mobx_1.observable,
            _worksDraftsRightsHolderPaginationInfo: mobx_1.observable,
            matchWorksSelectionSearchQuery: mobx_1.computed,
            getWorksDraftsRightsHolder: mobx_1.action,
            destroyWorksDraftsRightsHolderPaginationInfo: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    get matchWorksSelectionSearchQuery() {
        return this._matchWorksSelectionQuery;
    }
    getWorksDraftsRightsHolder(rightsHolderId, pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let response;
                if (search) {
                    const axiosResponse = yield searchAPI.searchWorksDraftsRH(rightsHolderId, pagination, search);
                    response = axiosResponse.data;
                }
                else {
                    const axiosResponse = yield workAPI.worksDraftsRH(rightsHolderId, pagination);
                    response = axiosResponse.data;
                }
                (0, mobx_1.runInAction)(() => {
                    this._worksDraftsRightsHolder = response;
                    if (pagination.limit && pagination.page && response) {
                        this._worksDraftsRightsHolderPaginationInfo = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page);
                    }
                });
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    get worksDraftsRightsHolder() {
        return this._worksDraftsRightsHolder;
    }
    get worksDraftsRightsHolderPaginationInfo() {
        return this._worksDraftsRightsHolderPaginationInfo;
    }
    destroyWorksDraftsRightsHolderPaginationInfo() {
        this._worksDraftsRightsHolderPaginationInfo = undefined;
    }
    setMatchWorksSelectionSearchQuery(matchWorksSelectionSearchQuery) {
        this._matchWorksSelectionQuery = matchWorksSelectionSearchQuery;
    }
}
exports.WorkSearchStore = WorkSearchStore;
